import { Text, VStack } from '@genial/components';
import { Spacing, Typography } from '@genial/design-tokens';
import React from 'react';

interface DetailsFieldProps {
  label: string;
  value: React.ReactNode;
  testID?: string;
}

export const DetailsField: React.FC<DetailsFieldProps> = ({ label, value, testID }) => (
  <VStack space={Spacing['stack.quarck']} w="full" testID={testID}>
    <Text
      variant="semibold"
      fontSize={Typography['fontsize.md']}
      color="neutral.darkest"
      lineHeight="distant">
      {label}
    </Text>
    {typeof value === 'string' ? (
      <Text
        variant="regular"
        fontSize={Typography['fontsize.md']}
        color="neutral.darkest"
        lineHeight="distant">
        {value || '--'}
      </Text>
    ) : (
      value
    )}
  </VStack>
);
